import * as React from 'react';
import { Form, Input, Button, message } from 'antd';
import { getMessageCode, checkMobile } from "@/fetch/api/personal";
import SliderValidate from "@/components/SliderValidate";
import { Local } from '@/utils/local';
import "./style.less";

class MessageCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev.yunduoketang.cn',
      mobile: "",
      second: 60,
      disabled: false,
      sending: true,
      sliderVisible: false,
      x: 0,
      y: 0,
      rember_x: 0,
      rember_y: 0
    };
  }

  onShowSlider = () => {
    this.setState({
      sliderVisible: true
    });
  };
  sendCode = position => {
    getMessageCode({
      mobile: this.props.mobile,
      x: Math.round(position.x),
      y: Math.round(position.y)
    }, this.state.domain).then(res => {
      if (res.success) {
        this.setState({
          rember_x: position.x,
          rember_y: position.y
        });

        if (Local.get(this.props.mobile)) {
          Local.remove(this.props.mobile);
        }

        let second = this.state.second;

        let _this = this;

        setTimeout(() => {
          _this.hideSlider();
        }, 1000);
        const timer = setInterval(() => {
          this.setState({
            second: second--,
            sending: false,
            disabled: true
          }, () => {
            if (second === 0) {
              clearInterval(timer);

              _this.setState({
                second: 60,
                sending: true,
                disabled: false
              });
            }
          });
        }, 1000);
      } else {
        message.error(res.message);
      }
    });
  };
  getSliderPosition = position => {
    console.log(position, "position=========");
    this.setState({
      sliderVisible: false,
      x: position.x,
      y: position.y
    }, () => {
      this.sendCode();
    });
  };
  hideSlider = () => {
    this.setState({
      sliderVisible: false
    });
  };

  componentDidMount() {
    this.props.triggerRef(this);
  }

  render() {
    const {
      state
    } = this;
    return <div data-inspector-line="81" data-inspector-column="6" data-inspector-relative-path="src\\containers\\PersonalCenter\\PersonalSetting\\components\\MessageCode\\index.jsx" style={{
      display: "inline-block"
    }}>
        <Button data-inspector-line="82" data-inspector-column="8" data-inspector-relative-path="src\\containers\\PersonalCenter\\PersonalSetting\\components\\MessageCode\\index.jsx" onClick={this.props.validateMobile} className={state.sending ? "code-button" : "disable-button"} disabled={state.disabled}>
          {state.sending ? <span data-inspector-line="84" data-inspector-column="10" data-inspector-relative-path="src\\containers\\PersonalCenter\\PersonalSetting\\components\\MessageCode\\index.jsx" className="send-code">获取验证码</span> : <span data-inspector-line="85" data-inspector-column="10" data-inspector-relative-path="src\\containers\\PersonalCenter\\PersonalSetting\\components\\MessageCode\\index.jsx" className="timer-code">{this.props.type == 'register' ? `${state.second}秒后重发` : `重新发送（${state.second}s）`}</span>}
        </Button>
        {state.sliderVisible && <SliderValidate data-inspector-line="87" data-inspector-column="30" data-inspector-relative-path="src\\containers\\PersonalCenter\\PersonalSetting\\components\\MessageCode\\index.jsx" sliderVisible={state.sliderVisible} handleCancelVerify={this.hideSlider} callback={this.sendCode} type={this.props.type} />}
      </div>;
  }

}

export default MessageCode;